<div class="progress-circle-wrapper">
  <div class="spinner">
    <mat-progress-spinner class="main" [color]="color" [mode]="'determinate'" [value]="percent" [diameter]="diameter"> </mat-progress-spinner>
    <mat-progress-spinner class="track" [color]="color" [mode]="'determinate'" [value]="100" [diameter]="diameter"> </mat-progress-spinner>
  </div>
  <span class="progress-circle-label">{{ percent }}</span>
</div>
